var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 333,
    viewBox: "0 0 1920 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9833L122.903 4.32752C155.997 2.53533 189.187 4.03796 221.983 8.81322L691.841 77.2262C733.557 83.3002 775.874 84.0742 817.785 79.5297L1518.45 3.55337C1570.71 -2.11342 1623.54 0.496322 1674.99 11.2864L1920 62.6736V333H0V10.9833Z",
    fill: "#0A84FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBlue);
export default __webpack_public_path__ + "static/media/footer-blue.1f31b5abf88c3b946e45d444bf572959.svg";
export { ForwardRef as ReactComponent };